<div class="device-container">
  <div class="hw-buttons hw-buttons--left" [class.hidden]="isLocked">
    <button (click)="pressVolumeUp()"   aria-label="Volume Up">  <span>▲</span><small>VOL+</small></button>
    <button (click)="pressVolumeDown()" aria-label="Volume Down"><span>▼</span><small>VOL−</small></button>
  </div>

  <div class="screen-wrapper" #screenWrapper [style.height]="screenHeight">
    <div class="speaker"></div>
    <div class="camera"></div>

    <div class="screen-overlay" *ngIf="!wsUrl">
      <div class="screen-logo">XP</div>
      <div class="screen-sub">to start a live session</div>
    </div>

    <img #screenImage class="device-image" alt="Mobile stream image" />
    <canvas #screenCanvas class="device-canvas"></canvas>
    <canvas #overlayCanvas class="device-canvas device-overlay"></canvas>
  </div>

  <div class="hw-buttons hw-buttons--right" [class.hidden]="isLocked">
    <button (click)="pressBack()"    aria-label="Back">   <span>◀</span><small>BACK</small></button>
    <button (click)="pressHome()"    aria-label="Home">   <span>⬤</span><small>HOME</small></button>
    <button (click)="pressRecents()" aria-label="Recents"><span>▣</span><small>APPS</small></button>
  </div>

  <div class="gesture-toolbar" [class.hidden]="isLocked">

    <!-- Multi-finger buttons -->
    <div class="gesture-buttons">
      <button
        *ngFor="let btn of multiFingerButtons"
        class="gesture-btn"
        [class.active]="gestureMode === btn.mode"
        (click)="setGestureMode(btn.mode)"
        [title]="btn.label">
        <span class="gesture-icon">{{ btn.icon }}</span>
        <span class="gesture-label">{{ btn.label }}</span>
      </button>

      <!-- Back to 1-finger -->
      <button
        class="gesture-btn gesture-btn--primary"
        [class.active]="gestureMode === '1finger'"
        (click)="setGestureMode('1finger')"
        title="1 Finger (Auto-detect)">
        <span class="gesture-icon">☝️</span>
        <span class="gesture-label">1 Finger</span>
      </button>
    </div>

    <!-- Refresh stream button — lives in the gesture toolbar, never on a status bar -->
    <button
      class="gesture-btn gesture-btn--refresh"
      [disabled]="isRefreshing"
      (click)="refreshStream()"
      title="Refresh stream if stuck on a frame">
      <span class="gesture-icon" *ngIf="!isRefreshing">⟳</span>
      <span class="refresh-spinner" *ngIf="isRefreshing"></span>
      <span class="gesture-label">{{ isRefreshing ? 'Refreshing…' : 'Refresh' }}</span>
    </button>

  </div>
</div>